import {store} from './../../plugins/vuex/index'
import {ARTISIO_ACTIVE_LANGUAGE} from "@/modules/constants";

export default {
  getAvailableLocales() {
    const obj = JSON.parse(localStorage.getItem('AVAILABLE_LOCALES'));
    if (!obj) {
      return [];
    }

    let keys = Object.keys(obj);
    let returnArr = [];

    for (let i = 0; i < keys.length; i++) {
      returnArr.push({
        key: keys[i],
        name: obj[keys[i]]
      });
    }
    return returnArr;
  },
  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   * @param obj
   * @param fields
   */
  initTranslatableFields(obj, fields) {
    const locales = this.getAvailableLocales();
    fields.forEach((fieldObj) => {
      obj[fieldObj.name] = {};
      locales.forEach((localeObj) => {
        obj[fieldObj.name][localeObj.key] = '';
      });
    });
  },
  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   * @returns {*}
   */
  getMasterLanguage() {
    if (store.state && store.state.global && Object.keys(store.state.global.locales).length > 0) {
      return store.state.global.locales.master_language
    }
    return {key: 'en', name: 'English'}
  },
  setLanguage(lang, reload = false) {
    localStorage.setItem(ARTISIO_ACTIVE_LANGUAGE, lang)
    if (reload) {
      window.location.reload()
    }
  },
  getLanguage() {
    return localStorage.getItem(ARTISIO_ACTIVE_LANGUAGE)
  }
}
